import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-connect-agoda-messaging',
  templateUrl: './connect-agoda-messaging.component.html',
  styleUrls: ['./connect-agoda-messaging.component.scss'],
})
export class ConnectAgodaMessagingComponent implements OnInit {
  @Output() stepComplete: EventEmitter<string> = new EventEmitter();

  constructor(private readonly router: Router) { }

  ngOnInit(): void { }

  back() {
    window.history.back();
  }

  progress() {
    this.stepComplete.emit();
  }
}
